import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectCashBankCardsTravelDocumentsAndPassportsStep = (state) => state.get('cashBankCardsTravelDocumentsAndPassportsStep');

const makeSelectCashBankCardsTravelDocumentsAndPassportsStep = () => createSelector(
  selectCashBankCardsTravelDocumentsAndPassportsStep,
  (cashBankCardsTravelDocumentsAndPassportsStepState) => ({
    // whatHappenedToYourBaggageAndPersonalItems: mapWithDefault(
    //   cashBankCardsTravelDocumentsAndPassportsStepState,
    //   () => cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'whatHappenedToYourBaggageAndPersonalItems']),
    //   ''
    // ),
    // hasYourBaggageBeenReturnedToYou: mapWithDefault(
    //   cashBankCardsTravelDocumentsAndPassportsStepState,
    //   () => cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'hasYourBaggageBeenReturnedToYou']),
    //   ''
    // ),

    // dateWhenYourLuggageWasReturned: mapWithDefault(
    //   cashBankCardsTravelDocumentsAndPassportsStepState,
    //   () => cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'dateWhenYourLuggageWasReturned']),
    //   ''
    // ),

    // infoBaggageDelayItems: mapWithDefault(cashBankCardsTravelDocumentsAndPassportsStepState, () => cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'infoBaggageDelayItems']) && cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'infoBaggageDelayItems']).toJS(), ''),

    whatItemsAreYouClaimingFor: mapWithDefault(
      cashBankCardsTravelDocumentsAndPassportsStepState,
      () => cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'whatItemsAreYouClaimingFor']),
      ''
    ),

    // infoEssentialMedicationItems: mapWithDefault(cashBankCardsTravelDocumentsAndPassportsStepState, () => cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'infoEssentialMedicationItems']) && cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'infoEssentialMedicationItems']).toJS(), ''),
    // infoJewelleryOrTraditionalWatchesItems: mapWithDefault(cashBankCardsTravelDocumentsAndPassportsStepState, () => cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'infoJewelleryOrTraditionalWatchesItems']) && cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'infoJewelleryOrTraditionalWatchesItems']).toJS(), ''),
    // infoLaptopsTabletsOrCamerasItems: mapWithDefault(cashBankCardsTravelDocumentsAndPassportsStepState, () => cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'infoLaptopsTabletsOrCamerasItems']) && cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'infoLaptopsTabletsOrCamerasItems']).toJS(), ''),
    // infoOtherUnspecifiedItems: mapWithDefault(cashBankCardsTravelDocumentsAndPassportsStepState, () => cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'infoOtherUnspecifiedItems']) && cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'infoOtherUnspecifiedItems']).toJS(), ''),
    // infoSpecifiedHighValueItems: mapWithDefault(cashBankCardsTravelDocumentsAndPassportsStepState, () => cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'infoSpecifiedHighValueItems']) && cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'infoSpecifiedHighValueItems']).toJS(), ''),
    infoBankCardsOrTravelDocumentsItems: mapWithDefault(cashBankCardsTravelDocumentsAndPassportsStepState, () => cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'infoBankCardsOrTravelDocumentsItems']) && cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'infoBankCardsOrTravelDocumentsItems']).toJS(), ''),
    infoCashItems: mapWithDefault(cashBankCardsTravelDocumentsAndPassportsStepState, () => cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'infoCashItems']) && cashBankCardsTravelDocumentsAndPassportsStepState.getIn(['form', 'infoCashItems']).toJS(), ''),
  })
);

const makeSelectCashBankCardsTravelDocumentsAndPassportsStepErrors = () =>
  createSelector(selectCashBankCardsTravelDocumentsAndPassportsStep, (state) => state.get('errors'));

export {
  makeSelectCashBankCardsTravelDocumentsAndPassportsStep,
  makeSelectCashBankCardsTravelDocumentsAndPassportsStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.CashBankCardsTravelDocumentsAndPassports/selectors.js